/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { AdminCreateSurveyMarkSubmissions } from '../../models/admin-create-survey-mark-submissions';
import { SurveyMarksSubmissionDto } from '../../models/survey-marks-submission-dto';

export interface AdminCreateSurveyMarksSubmission$Params {
  body: AdminCreateSurveyMarkSubmissions;
}

export function adminCreateSurveyMarksSubmission(
  http: HttpClient,
  rootUrl: string,
  params: AdminCreateSurveyMarksSubmission$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarksSubmissionDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    adminCreateSurveyMarksSubmission.PATH,
    'post',
  );
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarksSubmissionDto>;
      }),
    );
}

adminCreateSurveyMarksSubmission.PATH = '/admin/surveyMarks/submissions';
